import { gql } from "@apollo/client";

export const ASSET_INFO = gql`
  fragment assetInfo on Asset {
    id
    name
    engName
    duration
  }
`;
export const ROOM_INFO = gql`
  fragment roomInfo on Room {
    id
    name
    engName
    minimumBalance
    isRequirePassword
    isRequireMinimumBalance
    password
    isBugOpen
    sst
  }
`;
export const BET_OPTION_INFO = gql`
  fragment betOptionInfo on BetOption {
    id
    name
    engName
    options {
      id
      name
      engName
      profit
    }
  }
`;
export const STAFF_INFO = gql`
  fragment staffInfo on Staff {
    id
    staffId
    fullname
  }
`;
export const MEMBER_INFO = gql`
  fragment memberInfo on Member {
    id
    username
    nickname
    memberId
    balance
    updatedAccount
    isTestUser
    memberLevel
    profileImage
    account {
      accountNo
      bankName
      accountName
    }
    identity {
      cardName
      cardNo
      cardImageUrl
    }
    isVerified
    isPeningIdentity
    accountType
    crypto {
      network
      address
    }
  }
`;

export const TRANSACTION_INFO = gql`
  fragment transactionInfo on Transaction {
    id
    transactionNo
    member {
      id
      nickname
      memberId
      updatedAccount
      account {
        accountNo
        bankName
        accountName
      }
    }
    amount
    action
    status
    createdAt
  }
`;

export const MESSAGE_INFO = gql`
  fragment messageInfo on Message {
    id
    isAdmin
    chatRoom {
      id
    }
    member {
      id
      memberId
      nickname
      profileImage
    }
    text {
      message
      imageUrl
      isImage
    }
    createdAt
  }
`;

export const BET_INFO = gql`
  fragment betInfo on Bet {
    id
    amount
    difference
    updatedAmount
    lottery {
      id
      lotteryNo
    }
    options {
      id
      name
      engName
    }
    createdAt
    member {
      id
      memberId
      nickname
    }
  }
`;

export const OPTION_INFO = gql`
  fragment optionInfo on Option {
    id
    name
    engName
    profit
  }
`;

export const BRANCH_INFO = gql`
  fragment branchInfo on Branch {
    id
    name
    branchLink
    sst
  }
`;

export const DIGITAL_WALLET_INFO = gql`
  fragment digitalWalletInfo on DigitalWallet {
    id
    btc {
      address {
        address
        isActive
      }
      address_omni {
        address
        isActive
      }
      address_erc20 {
        address
        isActive
      }
    }
    usdt {
      address {
        address
        isActive
      }
      address_omni {
        address
        isActive
      }
      address_erc20 {
        address

        isActive
      }
    }
  }
`;

export const DEPOSIT_INFO = gql`
  fragment depositInfo on DepositSetting {
    id
    short {
      percent
      duration
      min
      max
      enabled
    }
    medium {
      percent
      duration
      min
      max
      enabled
    }
    long {
      percent
      duration
      min
      max
      enabled
    }
  }
`;
